import {Component} from '@angular/core';


/**
 * A footer that contains information and possible actions.  Just a shell to put what you need.
 */
@Component({
  selector: 'clo-information-footer',
  template: `
    <footer class="info-footer">
      <ng-content></ng-content>
    </footer>
    `,
  styleUrls: ['./info-footer.css']
})
export class CloInformationFooter {

  constructor() { }

}
